import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import * as State from 'containers/desktop/KnowledgeBases/State';
import DocumentListItem from 'containers/desktop/KnowledgeBases/components/DocumentListItem';
import * as Document from 'containers/desktop/KnowledgeBases/types/Document';
import * as KnowledgeBase from 'containers/desktop/KnowledgeBases/types/KnowledgeBase';
import { Handlers } from 'containers/desktop/KnowledgeBases/useState';

interface Props {
	state: State.Type;
	handlers: Handlers;
}

const Detail = ({ state, handlers }: Props) => {
	const { classes } = useStyles();
	const { t } = useTranslation();

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file: File | null = e.target.files?.[0] ?? null;
		handlers.createAndSetFile(file);
	};

	const knowledgeBase = state.knowledgeBases.find(
		(knowledgeBase: KnowledgeBase.Type) => knowledgeBase.id === state.currentKnowledgeBaseId
	);

	if (!knowledgeBase) {
		return <div>{t('admin:KNOWLEDGE_BASES_NOT_FOUND')}</div>;
	}

	return (
		<div>
			<button
				className="btn btn-primary btn-sm"
				onClick={() => handlers.setCurrentKnowledgeBaseId(null)}
			>
				<FontAwesomeIcon icon={faArrowLeft} /> {t('_general:BACK')}
			</button>
			<hr />
			<h3>{knowledgeBase.name}</h3>
			<div className={classes.uploadContainer}>
				<input type="file" onChange={handleFileChange} />
				<button
					className="btn btn-primary btn-sm"
					onClick={handlers.uploadDocument}
					disabled={!state.file}
				>
					<FontAwesomeIcon icon={faUpload} /> {t('admin:UPLOAD_DOCUMENTS')}
				</button>
			</div>
			{knowledgeBase.documents.map((document: Document.Type) => (
				<DocumentListItem key={document.id} document={document} handlers={handlers} />
			))}
		</div>
	);
};

export default Detail;

export const useStyles = tss.create({
	container: {
		height: '100%',
		padding: '20px 20px',
		display: 'flex',
		flexDirection: 'column',
	},
	uploadContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		border: '1px solid #ccc',
		padding: '10px',
		backgroundColor: '#f0f0f0',
		margin: '20px 0',
	},
	document: {
		fontSize: '16px',
		padding: '10px 20px',
		paddingRight: '10px',
		marginBottom: '-1px',
		display: 'flex',
		gap: '20px',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		border: '1px solid #ccc',
	},
	documentType: {
		fontSize: '16px',
		fontWeight: 'bold',
		flexGrow: 0,
	},
	documentInfo: {
		fontSize: '16px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		flexGrow: 1,
	},
	documentInfoRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '10px',
		justifyContent: 'space-between',
		fontSize: '0.8em',
	},
});
